/**
 * CaaS API Stub
 * This is a stub implementation for the CaaS API.
 * For full implementation, install the CaaS API client in your funnel project.
 * 
 * This allows the template to compile without requiring CaaS API,
 * but GHL+CaaS booking will only work if you provide the actual implementation.
 */

export interface FreeSlotsResponse {
  agencyId: string;
  freeSlots: Record<string, any[]>;
}

export async function getAvailableSlots(
  agencyId: string,
  startDate: number,
  endDate: number,
  timezone?: string
): Promise<FreeSlotsResponse> {
  throw new Error(
    'CaaS API not implemented. Please install the CaaS API client or use a different booking provider.'
  );
}

export async function preBookAppointment(params: {
  agencyId: string;
  appointmentData: {
    prospect_name: string;
    prospect_email: string;
    prospect_phone: string;
    appointment_date: string;
    contact_id?: string;
    notes?: string;
  };
}): Promise<{ appointmentId: string }> {
  throw new Error(
    'CaaS API not implemented. Please install the CaaS API client or use a different booking provider.'
  );
}

export function formatPhoneForAPI(phone: string): string {
  // Basic phone formatting - remove non-digits
  return phone.replace(/\D/g, '');
}

export function formatAppointmentDate(
  date: Date,
  format?: string,
  timezone?: string
): string {
  // Basic ISO format
  return date.toISOString();
}
